<template>
  <card-item
    card="item_alif_order"
    :tabs="tabs"
    :disableId="true"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['alif-orders'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "info",
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>